// @ts-check
import React, { Component } from "react";
import Swiper from "react-slick";
import { Breakpoints } from "ReactComponents/Shared/Constants/breakpoints";
import ProductSliderProductItem from "ReactComponents/ProductSlider/product-slider-product-item";
import SliderNavigationButton from "ReactComponents/Shared/SliderNavigation/slider-navigation-button";
import IconViewAllArrowRight from "ReactComponents/Shared/Icons/icon-viewall-arrow-right";

class ProductSlider extends Component {
    /**
     * @param {any} props
     */
    constructor(props) {
        super(props);
        this.state = {
            didMount: false
        };
    }

    componentDidMount() {
        this.setState({ didMount: true });
    }

    render() {
        const swiperSettings = {
            infinite: false,
            slidesToShow: 2.3,
            slidesToScroll: 2,
            arrows: true,
            prevArrow: <SliderNavigationButton arrowDirection="left" ariaLabel="Gå tilbage" />,
            nextArrow: <SliderNavigationButton arrowDirection="right" ariaLabel="Gå frem" />,
            centerMode: false,
            // centerPadding: "10px",
            easing: "ease",
            speed: 400,
            responsive: [
                {
                    breakpoint: Breakpoints.elephant + 320,
                    settings: {
                        slidesToShow: 2.3,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: Breakpoints.lion,
                    settings: {
                        slidesToShow: 1.05,
                        slidesToScroll: 1,
                        arrows: false
                    }
                }
            ]
        };

        const didMount = this.state.didMount;
        return (
            (this.props.Works.length > 0 || !this.props.HideWhenEmpty) && (
                <div className="product-slider-container content-module">
                    <div>
                        {(this.props.TitleText ||
                            this.props.ViewAllLink ||
                            this.props.ViewAllProductsLink) && (
                            <div className="product-slider__header-container content-module-header">
                                {this.props.TitleText && (
                                    <h2
                                        className="product-slider__header"
                                        dangerouslySetInnerHTML={{ __html: this.props.TitleText }}
                                    />
                                )}

                                {
                                    //This is a temporary fix - ViewAllProductsLink should be phased out and replaced it ViewAllLink And ViewAllLinkText
                                    this.props.ViewAllProductsLink ? (
                                        <div
                                            className="product-slider__go-to-link"
                                            dangerouslySetInnerHTML={{
                                                __html: this.props.ViewAllProductsLink
                                            }}
                                        />
                                    ) : (
                                        this.props.ViewAllLink && (
                                            <div className="product-slider__go-to-link">
                                                <a href={this.props.ViewAllLink}>
                                                    {this.props.ViewAllLinkText}
                                                    <span className="sr-only">
                                                        {" "}
                                                        {this.props.TitleText}
                                                    </span>{" "}
                                                    <IconViewAllArrowRight />
                                                </a>
                                            </div>
                                        )
                                    )
                                }
                            </div>
                        )}

                        <div className="product-slider custom-slick-slider">
                            {didMount && this.props.Works.length > 0 ? (
                                <Swiper {...swiperSettings}>
                                    {this.props.Works.map((work, index) => {
                                        const product = work.Products[0],
                                            mediaTypes = work.MediaTypes;

                                        return (
                                            <ProductSliderProductItem
                                                key={index}
                                                product={product}
                                                mediaTypes={mediaTypes}
                                                labels={this.props.Labels}
                                                productDeliveryInfo={this.props.ProductDeliveryInfo}
                                            />
                                        );
                                    })}
                                </Swiper>
                            ) : (
                                <div className="empty-product-slider">
                                    <div
                                        className="empty-product-slider__text"
                                        dangerouslySetInnerHTML={{ __html: this.props.EmptySliderText }}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )
        );
    }
}
export default ProductSlider;
